import { validatePersonalDetails } from './personal-details';
import { validateBankDetails } from './bank-details';
import { validateTaxDetails } from './tax-details';
import { validateAllRightToWork } from './right-to-work';

// TODO: call validate function in every component
export async function validate(field) {
  const sectionName = field.name.split('.')[0];
  switch (sectionName) {
    case 'personalDetails':
      return await validatePersonalDetails(field);
    case 'bankDetails':
      return await validateBankDetails(field);
    case 'taxDetails':
      return await validateTaxDetails(field);
  }
}

export async function validateOneDocument(document, changedField) {
  switch (document.name) {
    case 'workRights':
      return validateAllRightToWork(document.fields, changedField);
    default:
      // null to indicate there are no document matching
      return null;
  }
}
